"use strict";

import angular from "angular";

import template from "./help-item-topics.component.html";
import "./themes/help-item-topics.component.scss";
import "./themes/help-item-topics-dark.component.scss";

class HelpItemTopicsComponent {
    constructor() {
        this.contentType = "";
    }

    $onInit() {}

    $onDestroy() {}

    $onChanges(changes) {}
}

HelpItemTopicsComponent.$inject = [];

const name = "helpItemTopicsComponent";
const def = {
    bindings: {
        content: "<"
    },
    controller: HelpItemTopicsComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
